import { useRouter } from 'next/router'
import styled from 'styled-components'
import * as React from 'react'
import ProfileImage from '../../profile/image'
import { FbEnrichedUser } from '../../../interfaces/User'

const OuterDiv = styled.div`
  width: calc(100% - 30px);
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-radius: 10px;
  cursor: pointer;

  :hover {
    background-color: #323232;
  }
`

const InnerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

const Title = styled.span<{ neutral: boolean; hasTitle?: boolean }>`
  color: ${(props) => (props.neutral ? 'white' : 'rgb(48, 209, 88)')};
  font-size: 14px;
  font-weight: 600;
  white-space: pre;
  max-width: ${(props) => (props.hasTitle ? '300px' : '')};
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 15px;

  @media (min-width: 43em) {
    font-size: 17px;
    max-width: ${(props) => (props.hasTitle ? '400px' : '')};
  }
`

const VideoHitItem = ({
  user,
  onClick,
}: {
  user: FbEnrichedUser
  onClick: () => void
}): JSX.Element => {
  const router = useRouter()

  const handleOpenProfile = (address: string): void => {
    onClick()
    router.push(`/${address}`)
  }

  return (
    <OuterDiv onClick={() => handleOpenProfile(user.address)}>
      <InnerDiv>
        <ProfileImage item={user} size={45} />
        <Title neutral hasTitle>
          {user.displayName}
        </Title>
      </InnerDiv>
    </OuterDiv>
  )
}

export default VideoHitItem
